<template>
    <div class="mgs-help-page">
        <h2><i class="bi bi-question-circle-fill" style="color:#c9a84c;"></i> Help &amp; Walkthroughs</h2>
        <p class="mgs-help-intro">
            Step-by-step guided tours for the AML platform. Click <strong>Start tour</strong> on any
            walkthrough below and the page will guide you through each part of the feature.
        </p>

        <div v-if="alwaysFirstTime" class="mgs-help-test-banner">
            <i class="bi bi-tools"></i>
            <div>
                <strong>Testing mode is on.</strong>
                Walkthroughs will auto-launch every time you load the relevant page, regardless of whether you've seen them before.
                Toggle this off in <code>resources/js/tours/config.js</code> (set <code>ALWAYS_FIRST_TIME = false</code>).
            </div>
        </div>

        <div v-if="tourList.length === 0" class="mgs-help-empty">
            <i class="bi bi-journal" style="font-size:32px;display:block;margin-bottom:10px;"></i>
            No walkthroughs are available yet.
        </div>

        <div v-for="tour in tourList" :key="tour.id" class="mgs-help-tour-card">
            <div class="mgs-help-tour-icon">
                <i class="bi bi-play-circle-fill"></i>
            </div>
            <div class="mgs-help-tour-body">
                <h3 class="mgs-help-tour-title">{{ tour.title }}</h3>
                <p class="mgs-help-tour-desc">{{ tour.description }}</p>
            </div>
            <div class="mgs-help-tour-actions">
                <button class="aml_btn aml_btn_primary" @click="launch(tour)">
                    <i class="bi bi-play-fill"></i> Start tour
                </button>
                <span v-if="seenMap[tour.id]" class="mgs-help-tour-status">
                    Last viewed {{ formatDate(seenMap[tour.id]) }}
                </span>
                <span v-else class="mgs-help-tour-status">Not yet viewed</span>
            </div>
        </div>
    </div>
</template>

<script>
import { tours } from './registry.js';
import { startTour } from './launcher.js';
import { ALWAYS_FIRST_TIME } from './config.js';

const STORAGE_KEY = 'mgs_tours_seen_v1';

export default {
    name: 'HelpWalkthroughs',

    inject: {
        amlSetPage: { default: null },
    },

    data() {
        return {
            tourList: tours,
            seenMap: this.loadSeen(),
            alwaysFirstTime: ALWAYS_FIRST_TIME,
        };
    },

    methods: {
        loadSeen() {
            try {
                const raw = localStorage.getItem(STORAGE_KEY);
                return raw ? JSON.parse(raw) : {};
            } catch (e) {
                return {};
            }
        },

        launch(tour) {
            // If the tour wants to start on a particular AML page, navigate there first.
            if (tour.autoLaunchOn && tour.autoLaunchOn.page && this.amlSetPage) {
                this.amlSetPage(tour.autoLaunchOn.page);
                this.$nextTick(() => {
                    setTimeout(() => startTour(tour.id), 200);
                });
            } else {
                startTour(tour.id);
            }
        },

        formatDate(iso) {
            try {
                const d = new Date(iso);
                return d.toLocaleString();
            } catch (e) {
                return iso;
            }
        },
    },
};
</script>
